(function() {
  "use strict";

  angular.module("AuthenticationSettings")

    // .constant("GroupTestAuthApiUrl", "https://auth.printix.net/ms/graph/activate")

    .constant('AUTHENTICATION_TABS', [
      {
        icon: null,
        section: 'setup',
        caption: 'Setup',
        selected: false,
        show: true,
      },
      // IdP tabs (azure, google, oidc, okta, onelogin) injected here at controller
      // link-time from IDP_PROVIDERS — see calibrateTabs() below.
      {
        icon: null,
        section: 'vertical',
        caption: 'Vertical',
        selected: false,
        show: false,
      },
      {
        icon: null,
        section: 'ad',
        caption: 'ActiveDirectory',
        selected: false,
        show: true,
      },
      {
        icon: null,
        section: 'selfRegister',
        caption: 'SelfRegistration',
        selected: false,
        show: true,
      }
    ])

    .controller("AuthenticationSettingsController", [
      "$scope", "$rootScope", "$location", "$routeParams", "AUTHENTICATION_TABS", 'IDP_PROVIDERS', 'currentTenant', 'EventHandlerService',
      'EventServiceEvents',
      function(
        $scope, $rootScope, $location, $routeParams, AUTHENTICATION_TABS, IDP_PROVIDERS, currentTenant, EventHandlerService,
        EventServiceEvents
        ) {

        $scope.eventHandlerService = EventHandlerService;


        $scope.tenant = currentTenant;
        $scope.me = null;
        $scope.error = null;

        (function(){

          initEventHandler();
          calibrateTabs();
          initTab();
          setListeners();
          checkQueryParam();

        })();


        function checkQueryParam () {
          if ($routeParams['todo'] && $routeParams['todo'] === 'setup_auth') {
            if ($scope.tenant.info.todoMap.SETUP_AUTH) {
              $scope.tenant.removeToDoItem($scope.tenant.info.todoMap.SETUP_AUTH)
            }
          }
        }

        function initEventHandler() {
          $scope.eventHandlerService.deRegisterListeners();
        };

        $scope.$watch(function () {
          return $rootScope.currentUser
        }, function() {
          if ($rootScope.currentUser) {
            $scope.me = $rootScope.currentUser;
          }
        })

        function initTab () {
          if ($routeParams['authenticationSection']) {
            $scope.showSection = $routeParams['authenticationSection'];
          } else {
            $scope.showSection = 'setup';
          }
          sectionSpecificItems();
        }

        $scope.setSection = function(section) {
          $scope.showSection = section;
          const url = $location.path();
          $location.path(url, false).search({ authenticationSection: section });
          sectionSpecificItems();
        }

        function sectionSpecificItems () {
          switch ($scope.showSection) {
            case 'setup':
              $scope.helpCaption = "HelpAuthenticationSetup";
              break;
            case 'vertical':
              $scope.helpCaption = "HelpAuthenticationVertical";
              break;
            case 'ad':
              $scope.helpCaption = "HelpAuthenticationActiveDirectory";
              break;
            case 'selfRegister':
              $scope.helpCaption = "HelpAuthenticationSelfRegistration";
              break;
            default: {
              const descriptor = IDP_PROVIDERS.find(function (d) {
                return d.type === $scope.showSection;
              });
              if (descriptor) {
                $scope.helpCaption = descriptor.helpCaption;
              }
            }
          }
        }

        function calibrateTabs() {
          const idpTabs = IDP_PROVIDERS.map(function (descriptor) {
            return {
              icon: null,
              section: descriptor.type,
              caption: descriptor.caption,
              selected: false,
              show: true
            };
          });
          const insertAt = AUTHENTICATION_TABS.findIndex(function (t) {
            return t.section === 'setup';
          }) + 1;
          $scope.tabs = angular.copy(
            AUTHENTICATION_TABS.slice(0, insertAt)
              .concat(idpTabs)
              .concat(AUTHENTICATION_TABS.slice(insertAt))
          );
        }

        $scope.clearError = () => {
          $scope.error = null;
        }

        function setListeners () {
          $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.IDENTITY_PROVIDER_CREATED, function(name, data) {
            if ($scope.tenant.info.todoMap.SETUP_AUTH) {
              $scope.tenant.removeToDoItem($scope.tenant.info.todoMap.SETUP_AUTH)
            }
          });

          $scope.$on('REQUEST_ERROR_HELP', (name, data) => {
            $scope.error = data.error;
          })
        }

      }
    ]);
})();
